import createReactComponent from '../createReactComponent';
export default createReactComponent('minimize', 'IconMinimize', [
  ['path', { d: 'M15 19v-2a2 2 0 0 1 2 -2h2', key: 'svg-0' }],
  ['path', { d: 'M15 5v2a2 2 0 0 0 2 2h2', key: 'svg-1' }],
  ['path', { d: 'M5 15h2a2 2 0 0 1 2 2v2', key: 'svg-2' }],
  ['path', { d: 'M5 9h2a2 2 0 0 0 2 -2v-2', key: 'svg-3' }],
]);
